import { User } from '@apis'
import { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { StyleGrid } from './style'
import Empty from '@commons/empty'
import InstituteDoctorCard from '@commons/cards/instituteDoctor'
import InstituteDoctorCardLoader from '@commons/cards/instituteDoctor/loader'
import { useNavigate } from 'react-router-dom'
const Doctors = () => {
  const navigate = useNavigate()
  const { data: user } = useSelector((state: any) => state.user)
  const { items: doctors, loading } = useSelector(
    (state: any) => state.instituteDoctors,
  )
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    role: 'doctor',
    parentId: user?.id,
  })
  const fetchData = async (params, action = 'set') => {
    await User.list({
      params,
      state: 'instituteDoctors',
      action: action,
    }).catch(() => {})
  }

  const handleClick = async (event: any) => {
    const target = event.target as HTMLElement
    const cross = target.closest('[data-cross-type]')
    if (!!cross) {
      const type = cross.getAttribute('data-cross-type')
      const id = cross.getAttribute('data-cross-id')
      if (!!id) {
        const doctor = doctors?.find((doctor: any) => doctor?.id == id)

        switch (type) {
          case 'Edit':
            navigate(
              `/institution/staffs/doctor/${doctor?.name.toLowerCase().replaceAll(' ', '-')}-${id}`,
              {
                state: doctor,
              },
            )
            break
          case 'View':
            navigate(
              `/institution/staffs/doctor/profile/${doctor?.name.toLowerCase().replaceAll(' ', '-')}-${id}`,
              {
                state: doctor,
              },
            )
            break
        }
      }
    }
  }

  useEffect(() => {
    if (!doctors?.length) {
      fetchData(params)
    }
  }, [])

  return (
    <>
      {!!loading ? (
        <StyleGrid>
          {Array(6)
            .fill(0)
            ?.map((_, index: number) => {
              return (
                <Fragment key={index}>
                  <InstituteDoctorCardLoader />
                </Fragment>
              )
            })}
        </StyleGrid>
      ) : (
        <>
          {!!doctors?.length ? (
            <StyleGrid onClick={handleClick}>
              {doctors?.map((doctor) => {
                return (
                  <Fragment key={doctor?.id}>
                    <InstituteDoctorCard doctor={doctor} />
                  </Fragment>
                )
              })}
            </StyleGrid>
          ) : (
            <Empty />
          )}
        </>
      )}
    </>
  )
}

export default Doctors
